import moment from "moment-timezone";
import {formatUTCDate, formatUTCDateTime} from "@/core/utils/filters";

const map = {
  'hourly': 'hour',
  'daily': 'day',
  'weekly': 'isoWeek',
  'monthly': 'month',
  'quarterly': 'quarter',
  'yearly': 'year',
}
const addMap = {
  'hourly': 'hour',
  'daily': 'day',
  'weekly': 'week',
  'monthly': 'month',
  'quarterly': 'quarter',
  'yearly': 'year',
}
export default class Utils {

  // eslint-disable-next-line complexity
  static getListOfDates(type, from, to) {
    let endDate = to;
    if (!endDate) {
      endDate = moment.tz('America/Los_Angeles');
    } else {
      endDate = moment.tz(endDate,'America/Los_Angeles');
      if (moment(endDate).isAfter(moment())) {
        endDate = moment.tz('America/Los_Angeles');
      }
    }
    endDate = moment(endDate).utc(false);

    let momentIndexDate = moment.tz(from,'America/Los_Angeles').startOf(map[type]);

    const res = [];

    while (momentIndexDate.isBefore(endDate)) {
      res.push(momentIndexDate.toJSON());
      momentIndexDate.add(1, addMap[type])
    }

    return res;
  }

  static addEmptyRows(list, data, propName, emptyObject) {

    const exist = _.reduce(data, function (result, value,) {
      result.push(value[propName]);
      return result;
    }, []);
    const difference = _.difference(list, exist);

    const filledDiff = difference.map(key => ({
      [propName]: key,
    }));

    return [...data, ...filledDiff];
  }

  static filterPredicate = function (data, model) {
    const res = [];
    _.forEach(data, (v, k) => {
      if (v) {
        const filter = model.find((i) => i.name===k);
        res.push(filter.getPredicate(v));
      }
    });
    return res.join(" and ");
  };

  static filterValueSet = function (th, newValue) {
    const obj = _.reduce(
      newValue,
      (result, v, k) => {
        if (v!==th.filterData[k]) {
          return {...result, [k]: v ? v:undefined};
        }
        return result;
      },
      {}
    );

    th.$router.replace({
      query: {
        ...th.$route.query,
        ...obj,
      },
    });
  };

  static addMinutes = function (d, m) {
    return moment(d).add('minute', m).toDate()
  }
  static addHours = function (d, h) {
    return moment(d).add('hour', h).toDate()
  }
  static addDay = function (d, h) {
    return moment(d).add('day', h).toDate()
  }
  static addMonth = function (d, h) {
    return moment(d).add('month', h).toDate()
  }

  static copyToClipboard = function (text) {
    navigator.clipboard.writeText(text).then(function () {
      alert("Copied");
    }, function (err) {
      alert("Could not copy");
    });
  };

  static columnsBuilder(baseColumns, additColumns, insertIndex) {
    if( insertIndex==null ){
      return [
        ...baseColumns,
        ...additColumns,
      ];
    }
    return [
      ...baseColumns.slice(0, insertIndex),
      ...additColumns,
      ...baseColumns.slice(insertIndex)
    ];
  }
}
